import Vue from "vue";
import Router from "vue-router";
// import HelloWorld from '@/components/HelloWorld'

import Home from "@/pages/home";
import Solution from "@/pages/solution";
import industryPavilionCase from "@/pages/industryPavilionCase";
import industryPavilionCaseDetail from '@/pages/caseDetails/detail'
import creativeInteraction from "@/pages/creativeInteraction";
import news from "@/pages/news";
import newsDetail from "@/pages/newsDetail";
import about from "@/pages/about";
import contact from "@/pages/contact";

Vue.use(Router);
const originalPush = Router.prototype.push

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
const router = new Router({
  mode: "history",
  base: '/',
  // base: process.env.NODE_ENV == 'development' ? '/' : '333f',
  routes: [
    {
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/news/:id",
      name: "newsDetail",
      component: newsDetail,
    },
    {
      path: "/news",
      name: "news",
      component: news,
    },
    {
      path: "/aboutUs",
      name: "about",
      component: about,
    },
    {
      path: "/contact",
      name: "contact",
      component: contact,
    },
    {
      path: "/solution",
      name: "solution",
      component: Solution,
    },
    {
      path: "/industryPavilionCase",
      name: "industryPavilionCase",
      component: industryPavilionCase,
    },
    {
      path: '/industryPavilionCaseDetail',
      name: 'industryPavilionCaseDetail',
      component: industryPavilionCaseDetail,
      meta: {
        active: "/industryPavilionCase",
      },
    },
    {
      path: '/creativeInteraction',
      name: 'creativeInteraction',
      component: creativeInteraction
    }, {
      path: '*',
      redirect: {
        name: 'home'
      }
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      // 如果存在savedPosition（通过浏览器的前进/后退按钮触发），则使用它
      return savedPosition
    } else {
      // 否则滚动到顶部
      return { x: 0, y: 0 }
    }
  }
});

router.beforeEach((to, from, next) => {
  // 确保页面滚动到顶部
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // 使用平滑滚动效果
  });
  next();
});

export default router


// WEBPACK FOOTER //
// ./src/router/index.js